import { request } from '../../../../global/services/request'
import { Address } from '../store/store'

export async function getTimezones() {
  return await request({
    path: `/timezones`,
    method: 'GET'
  })
}

export async function getCountries() {
  return await request({
    path: `/countries`,
    method: 'GET'
  })
}

export async function getAddresses(accountId: string) {
  return await request({
    path: `/accounts/${accountId}?include=addresses`,
    method: 'GET'
  })
}

export async function postAddress(accountId: string, address: Address) {
  const body: { [key:string]: string } = {}

  if (address.businessName && address.businessName.trim() !== '') {
    body.address_line_one = address.businessName
  }

  if (address.addressLine1 && address.addressLine1.trim() !== '') {
    body.address_line_two = address.addressLine1
  }

  if (address.addressLine2 && address.addressLine2.trim() !== '') {
    body.address_line_three = address.addressLine2
  }

  if (address.city && address.city.trim() !== '') {
    body.locality = address.city
  }

  if (address.postcode && address.postcode.trim() !== '') {
    body.postcode = address.postcode
  }

  if (address.region && address.region.trim() !== '') {
    body.region = address.region
  }

  if (address.country) {
    body.country = address.country
  }

  return await request({
    path: `/accounts/${accountId}/addresses`,
    method: 'POST',
    body
  })
}

export async function patchAddress(accountId: string, address: Address) {
  return await request({
    path: `/accounts/${accountId}/addresses/${address.id}`,
    method: 'PATCH',
    body: {
      address_line_one: address.businessName,
      address_line_two: address.addressLine1,
      address_line_three: address.addressLine2,
      locality: address.city,
      postcode: address.postcode,
      region: address.region,     
      country: address.country
    }
  })
}